import Layout from '../../layout/index'

const mechanismRouter = {
  path: '/mechanism',
  component: Layout,
  redirect: '/mechanism/index',
  children: [
    {
      path: 'index',
      name: 'mechanism',
      component: () => import('../../views/mechanism/index')
    },
    {
      path: 'detail',
      name: 'mechanismDetail',
      component: () => import('../../views/mechanism/detail')
    }
  ]
}
export default mechanismRouter
